import "./App.css";
// import { HashRouter, Navigate, Route, Routes, Switch } from 'react-router-dom';

import { Home } from "./modules/pages/Home";
import { useEffect, useState } from "react";
import { AdminService } from './core/services/AdminService';
import { Route, Routes, HashRouter } from "react-router-dom";
import { Login2 } from "./core/auth/Login2";
import { FrameBuster } from "./modules/theme/Component/FrameBuster";
import { Singleton } from './core/services/Singleton';
import { SystemUtil } from "./modules/system/SystemUtil";
import { _PublicKeyInfo, _single } from "./core/services/dataBean/EntityCatalog";
import { ToastContainer } from "react-toastify";
import { env } from "./env";
import { HomePortal } from "./portal/componets/HomePortal";
import { LoginPortal } from "./portal/componets/LoginPortal";
import { NotFound } from "./modules/theme/NotFound";
import { PortalProvider } from "./portal/componets/hook/usePortalState";
import { HomeEncuesta } from "./portal/componets/HomeEncuesta";
import { isSameDay } from "./utils/helpers";


const _AdminService = new AdminService();

function TestEnvironmentBanner({ isVisible }: { isVisible: boolean }) {
  if (!isVisible) return null;

  return (
    <div className="test-environment-banner" role="status">
      AMBIENTE DE PRUEBAS
    </div>
  );
}

function App() {
  const single = Singleton.getInstance();
  const portal_type = env.PORTAL_TYPE ?? 1;

  const [isLogged, setIsLogged] = useState(false);
  const [yek, setYek] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const isTest = env.TEST_ENVIROMENT ?? false;

  useEffect(() => {
    const key = _single.getSessionItem('yek');
    const yekDate = _single.getSessionItem('yekDate');

    if (key && isSameDay(yekDate)) {
      single.encrypKey = key;
      setYek(key);
    } else {
      single.setSessionItem("yek", "");
      single.setSessionItem("yekDate", "");
    }

    getKey();
    FrameBuster();
  }, []);

  useEffect(() => {
    if (isLogged) {
      getKey();
    }
  }, [isLogged])

  const getKey = () => {
    setIsLoading(true);
    setHasError(false);

    _AdminService.securitymanager().subscribe({
      next: (resp: any) => {
        try {
          if (resp?.DataBeanProperties?.ObjectValue) {
            const key = resp.DataBeanProperties.ObjectValue.DataBeanProperties.Key;
            single.setSessionItem("yek", key);
            single.setSessionItem("yekDate", single.getCurrenDate());
            setYek(key);
          } else {
            console.warn("Security session key not found in response");
            setYek("");
          }
        } catch (error) {
          console.error("Error processing security response:", error);
          setHasError(true);
        } finally {
          setIsLoading(false);
        }
      },
      error: (err: any) => {
        console.error("Security manager service error:", err);
        setHasError(true);
        setIsLoading(false);
      }
    });
  };

  if (isLoading && !yek) {
    return (
      <>
        <TestEnvironmentBanner isVisible={isTest} />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
          <div className="custom-loader"></div>
          <p style={{ marginTop: '20px', color: '#0f1f67', fontWeight: 'bold' }}>Cargando sistema...</p>
        </div>
      </>
    );
  }

  if (hasError && !yek) {
    return (
      <>
        <TestEnvironmentBanner isVisible={isTest} />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <h4 style={{ color: 'red' }}>Error de conexión</h4>
        <p>No se pudo establecer una sesión segura con el servidor.</p>
        <button
          onClick={getKey}
          style={{
            marginTop: '20px',
            padding: '10px 20px',
            backgroundColor: '#0f1f67',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Reintentar
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      <TestEnvironmentBanner isVisible={isTest} />
      <ToastContainer newestOnTop position="top-right" autoClose={4000} hideProgressBar={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
      <HashRouter basename="/" future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        {portal_type === 1 ?
          <Routes>
            <Route path="/system" element={<SystemUtil view="e" />}></Route>
            <Route path="/login" element={<Login2 setIsLogged={setIsLogged} />}></Route>

            <Route path="/app/" element={<Home setIsLogged={setIsLogged} notFound={false} />}>
              <Route path=":module/:view/:param/:atribute" element={<Home setIsLogged={setIsLogged} notFound={false} />} />
              <Route path=":module/:view/:param" element={<Home setIsLogged={setIsLogged} notFound={false} />} />
              <Route path=":module/:view" element={<Home setIsLogged={setIsLogged} notFound={false} />} />
              <Route path=":module" element={<Home setIsLogged={setIsLogged} notFound={false} />} />
            </Route>
            <Route path="/" element={<Login2 setIsLogged={setIsLogged} />} />
            <Route path="*" element={<NotFound setIsLogged={setIsLogged} notFound={true} />} />
          </Routes>
          :
          <PortalProvider>
            <Routes>
              <Route path="/encuesta/:token" element={<HomeEncuesta />}>
                <Route path=":token" element={<HomeEncuesta />} />
              </Route>
              <Route path="/portal/" element={<HomePortal setIsLogged={setIsLogged} notFound={false} />}>
                <Route path=":page" element={<HomePortal setIsLogged={setIsLogged} notFound={false} />}>
                  <Route path=":param" element={<HomePortal setIsLogged={setIsLogged} notFound={false} />} >
                    <Route path=":recurso" element={<HomePortal setIsLogged={setIsLogged} notFound={false} />} />
                  </Route>
                </Route>
                <Route path="*" element={<NotFound setIsLogged={setIsLogged} notFound={true} />} />
              </Route>
              <Route path="/" element={<LoginPortal setIsLogged={setIsLogged} />} />
              <Route path="*" element={<NotFound setIsLogged={setIsLogged} notFound={true} />} />
            </Routes>
          </PortalProvider>
        }
      </HashRouter>
    </>
  );
}

export default App;
